const instances = new WeakMap()

const popover = {
  mounted(el, binding) {
    if (!binding.value) return

    const instance = new window.bootstrap.Popover(el, {
      trigger: 'hover focus',
      html: true,
      customClass: 'popover-size',
      placement: binding.arg || 'top',
      title: binding.value.title || '',
      content: binding.value.content || '',
    })

    instances.set(el, instance)
  },

  updated(el, binding) {
    const instance = instances.get(el)
    if (!instance) return

    instance.setContent({
      '.popover-header': binding.value?.title || '',
      '.popover-body': binding.value?.content || '',
    })
  },

  unmounted(el) {
    const instance = instances.get(el)
    if (instance) {
      instance.dispose()
    }
    instances.delete(el)
  },
}

export default popover
